import * as types from './constants';

// Unique Assignment Name
export const uniqueAssignmentNameRequest = data => (
  { type: types.UNIQUE_ASSIGNMENT_NAME_REQUEST, payload: data }
);

export const uniqueAssignmentNameDone = data => (
  { type: types.UNIQUE_ASSIGNMENT_NAME_DONE, payload: data }
);

export const uniqueAssignmentNameFailed = errors => (
  { type: types.UNIQUE_ASSIGNMENT_NAME_FAILED, payload: errors }
);

export const uniqueAssignmentNameReset = () => (
  { type: types.UNIQUE_ASSIGNMENT_NAME_RESET }
);